// extracted by mini-css-extract-plugin
export default {"item":"KnowledgeItem_item__fR334","item_text":"KnowledgeItem_item_text__npnRg","item_bg":"KnowledgeItem_item_bg__-PJFU","item_precent":"KnowledgeItem_item_precent__Ptewr"};